import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8v7sy86kc: FaireProductEntity = {
  token: "p_p8v7sy86kc",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Prasiolite (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/86316900d731a139b3d9657a94a8ca4dd66c5659ce09594b6146b456703b5d59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bed3d5746ed7126f995d675042699f7e0f5188d5fdbeb66b3e1b3f558913532b.jpeg",
    "https://cdn.faire.com/fastly/14a2e69decc3062f92e8d62668f10de4e48c1435cd574fb7bc9e8d56fbb4f909.jpeg",
    "https://cdn.faire.com/fastly/e5616848968ca86b9aca8f18552b0a18917a1b85280e1a85f9b498765d1f22b0.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:22.573Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
